var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cs from '../_util/classNames';
import { ConfigConsumer } from '../ConfigProvider';
var Group = /** @class */ (function (_super) {
    __extends(Group, _super);
    function Group() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderBtnGroup = function (_a) {
            var getPrefixCls = _a.getPrefixCls;
            var _b = _this.props, className = _b.className, style = _b.style, children = _b.children;
            var prefixCls = getPrefixCls('btn-group');
            var classNames = cs(prefixCls, className);
            return (React.createElement("div", { className: classNames, style: style }, children));
        };
        return _this;
    }
    Group.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderBtnGroup);
    };
    Group.propTypes = {
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        style: PropTypes.object,
    };
    Group.defaultProps = {
        style: {},
    };
    return Group;
}(Component));
export default Group;
